import React, { useContext, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import { schedulingContext } from '../../SchedulingContext';
import theme from 'assets';
import { EventTypology } from "helpers/Enums";
import moment from "moment";
import "moment/locale/it";
import TicketSchedule from './TicketSchedule';
import AbsenceSchedule from './AbsenceSchedule';
import { SimecUser } from "components";
import { LocalizationIds } from "helpers/Localizations";
import { useIntl } from "react-intl";
import Moment from "react-moment";


let useStyles = makeStyles()(() => ({
    tableCellWithBorder: {
        borderLeft: '1px solid',
        borderLeftColor: theme.palette.grey[300]
    },
    busyCell: {
        borderLeft: '1px solid',
        borderLeftColor: theme.palette.grey[300],
        cursor: 'pointer',
        textAlign: 'center',
        padding: 0
    },
    busyCellContentWrapper: {
        border: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.01)',
        borderRadius: 5,
        paddingTop: 1
    },
    busyTicketBox: {
        padding: 8,
        height: '100%',
        textAlign: 'center',
        marginBottom: 1,
        borderRadius: 5
    },
    evenRowTicketBox: {
        backgroundColor: 'rgb(249, 187, 5)',
    },
    oddRowTicketBox: {
        backgroundColor: 'rgb(255 230 156)',
    },
    busyAbsenceBox: {
        padding: 8,
        width: '100%',
        height: '100%',
        textAlign: 'center',
        marginBottom: 1,
        borderRadius: 5
    },
    evenRowAbsenceBox: {
        backgroundColor: 'rgb(249 129 5)',
    },
    oddRowAbsenceBox: {
        backgroundColor: 'rgb(255 175 93)',
    },
    secondRow: {
        background: theme.palette.grey[100]
    },
    evenRow: {
        backgroundColor: 'rgb(239, 239, 239, 0.5)'
    }
}));

let Results = () => {
    let { classes } = useStyles();
    let { formatMessage } = useIntl();

    let tableRef = useRef<HTMLTableElement>(null);

    let service = useContext(schedulingContext);

    useEffect(() => {
        if (tableRef?.current) {
            tableRef.current.style.height = `${window.innerHeight - tableRef.current.offsetTop - 20}px`;
        }
    }, [tableRef])


    return (
        <>
            {(service.scheduling == null
                || (service.scheduling != null && service.scheduling?.dates.length <= 0)) &&
                <Typography gutterBottom variant="subtitle2">No scheduling found</Typography>
            }
            {service.scheduling != null && service.scheduling?.dates.length > 0 &&
                <TableContainer ref={tableRef}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>{formatMessage({ id: LocalizationIds.Technician })}</TableCell>
                                {service.scheduling?.dates
                                    .map((date, index) =>
                                        <TableCell key={index} className={classes.tableCellWithBorder}>
                                            <Moment date={date} format="ddd DD/MM" />
                                        </TableCell>
                                    )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.scheduling.schedules
                                .map((schedule, index) =>
                                    <React.Fragment key={index}>
                                        {schedule.rows.map((row, ixRows) =>
                                            <TableRow key={ixRows} className={(index % 2) === 0 ? classes.evenRow : undefined}>
                                                {(ixRows === 0) &&
                                                    // questo è da mettere solo per la prima row di una certa persona
                                                    <TableCell rowSpan={schedule.rowSpan}>
                                                        <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                                                            <SimecUser username={schedule.username} />
                                                        </Typography>
                                                    </TableCell>
                                                }
                                                {row.cells.map((c, ix) =>
                                                    // qui cicliamo le celle sapendo che per ogni cella c'è un unico evento al max
                                                    <TableCell
                                                        key={ix}
                                                        colSpan={c.colSpan}
                                                        className={c.isBusy ? classes.busyCell : classes.tableCellWithBorder}
                                                        onClick={() => service.openScheduleDetails(c.eventDetail, c.isBusy)}
                                                    >
                                                        <div className={c.isBusy ? classes.busyCellContentWrapper : ''}>
                                                            {c.eventDetail != null &&
                                                                <React.Fragment>
                                                                    {c.eventDetail.eventTypology === EventTypology.Ticket &&
                                                                        <div className={`${classes.busyTicketBox} ${(index % 2) === 0 ? classes.evenRowTicketBox : classes.oddRowTicketBox}`}>
                                                                            <Typography variant="body2"><b>{c.eventDetail.ticketNr}</b> - <b>{c.eventDetail.customerName}</b></Typography>
                                                                            <Typography variant="body2"><b>{c.eventDetail.title}</b></Typography>
                                                                            <Typography variant="body2">
                                                                                dal {moment(c.eventDetail.startDate).format("DD/MM/YYYY")} al {moment(c.eventDetail.endDate).format("DD/MM/YYYY")}
                                                                            </Typography>
                                                                        </div>
                                                                    }
                                                                    {c.eventDetail.eventTypology === EventTypology.Absence &&
                                                                        <div className={`${classes.busyAbsenceBox} ${(index % 2) === 0 ? classes.evenRowAbsenceBox : classes.oddRowAbsenceBox}`}>
                                                                            <Typography variant="body2"><b>{c.eventDetail.title}</b></Typography>
                                                                            <Typography variant="body2">
                                                                                dal {moment(c.eventDetail.startDate).format("DD/MM/YYYY")} al {moment(c.eventDetail.endDate).format("DD/MM/YYYY")}
                                                                            </Typography>
                                                                        </div>
                                                                    }
                                                                </React.Fragment>
                                                            }
                                                        </div>
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                        )}
                                    </React.Fragment>
                                )}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            {service.scheduleDetails !== null &&
                <>
                    {service.scheduleDetails.eventTypology === EventTypology.Ticket &&
                        <TicketSchedule
                            ticketId={service.scheduleDetails.ticketId}
                            dateFrom={service.scheduleDetails.startDate}
                            dateTo={service.scheduleDetails.endDate}
                            onClose={service.closeScheduleDetails}
                        />
                    }
                    {service.scheduleDetails.eventTypology === EventTypology.Absence &&
                        <AbsenceSchedule
                            absenceId={service.scheduleDetails.absenceId}
                            onClose={service.closeScheduleDetails}
                        />
                    }
                </>
            }
        </>
    )
}

export default Results;